import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { AuthShell } from "@/components/AuthShell";
import { forgotPassword, fmtError } from "@/lib/api";
import { Loader2, MailCheck } from "lucide-react";

const fieldCls =
  "w-full bg-white border border-black/10 rounded-2xl px-4 py-3.5 text-sm text-[#1A1A1A] placeholder:text-[#A3A3A3] focus:outline-none focus:border-[#A78BFA] focus:ring-2 focus:ring-[#A78BFA]/15 transition-colors";

export default function ForgotPasswordPage() {
  const { slug } = useParams();
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError("");
    try {
      await forgotPassword(slug, email.trim().toLowerCase());
      setSent(true);
    } catch (err) {
      setError(fmtError(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthShell
      testId="forgot-page"
      subtitle="Recupero password"
      title="Nessun problema."
      footer={
        <Link to={`/${slug}/login`} data-testid="forgot-to-login" className="text-[#1A1A1A] underline underline-offset-4">
          Torna all'accesso
        </Link>
      }
    >
      {sent ? (
        <div className="text-center" data-testid="forgot-sent">
          <div className="h-14 w-14 mx-auto mb-5 rounded-full bg-gradient-to-br from-[#A78BFA] to-[#67E8F9] flex items-center justify-center">
            <MailCheck className="text-white" size={26} />
          </div>
          <p className="text-[#1A1A1A]">Controlla la tua casella email.</p>
          <p className="mt-2 text-sm text-[#4A4A4A] font-light">
            Se <span className="font-medium">{email}</span> è registrata in questo centro, riceverai
            entro pochi minuti un link per scegliere una nuova password. Il link vale un'ora.
          </p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <p className="text-sm text-[#4A4A4A] font-light">
            Scrivi l'email con cui accedi: ti mandiamo un link per reimpostare la password.
          </p>
          <label className="block">
            <span className="block text-[10px] tracking-[0.25em] uppercase text-[#737373] mb-2">Email</span>
            <input data-testid="forgot-email" type="email" required value={email}
              onChange={(e) => setEmail(e.target.value)} placeholder="tu@email.it" className={fieldCls} />
          </label>
          {error && (
            <div data-testid="forgot-error" className="text-sm text-[#B91C1C] bg-[#FEE2E2] border border-[#FCA5A5] rounded-2xl px-4 py-2.5">
              {error}
            </div>
          )}
          <button type="submit" data-testid="forgot-submit" disabled={submitting}
            className="w-full inline-flex items-center justify-center gap-2 bg-[#1A1A1A] hover:bg-[#333] disabled:opacity-60 text-white rounded-full px-6 py-3.5 text-sm tracking-wide">
            {submitting && <Loader2 size={16} className="animate-spin" />}
            {submitting ? "Invio…" : "Inviami il link"}
          </button>
        </form>
      )}
    </AuthShell>
  );
}
